import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';

import { SiteService, HeroService } from '../../../+state';

@Component({
  selector: 'elm-app-login',
  templateUrl: 'login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
  title$ = this.site.title$;

  logo$ = this.site.logo$;

  headerBackground$ = this.hero.heroBackground$;

  constructor(private site: SiteService, private hero: HeroService) {}
}
